import { useEffect, useState } from "react";

import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import Formulario from "../../Componentes/Utils/Formulario";
import FormComp from "../../Componentes/FormComp";
import SmallLoading from "../../Componentes/Utils/SmallLoading";

import { useModal } from "../../contexts/ModalContext";
import { useToast } from "../../contexts/ToastContext";
import useApi from "../../hooks/useApi";

// Normaliza qualquer formato de data ("YYYY-MM-DD", "YYYY-MM-DD HH:mm:ss" ou
// objeto Date) para "YYYY-MM-DD", que é o que o <input type="date"> aceita.
const toInputDate = (value) => {
    if (!value) return '';
    if (typeof value === 'string') return value.slice(0, 10);
    if (value instanceof Date && !isNaN(value)) {
        return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`;
    }
    return '';
};

const addDaysISO = (isoDate, days) => {
    if (!isoDate) return '';
    const base = new Date(`${isoDate}T00:00:00`);
    base.setDate(base.getDate() + days);
    const yyyy = base.getFullYear();
    const mm = String(base.getMonth() + 1).padStart(2, '0');
    const dd = String(base.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};

/** Mesma regra do backend: distancia ausente/inválida conta como 0 → viagem 1 (< 300). */
const incrementoRetornoPorFolga = (f) => {
    if (!f) return 0;
    const diasGozo = Number(f.dias_gozo) || 0;
    let distancia = 0;
    const raw = f.distancia;
    if (raw !== null && raw !== undefined && raw !== '') {
        const n = Number(raw);
        if (Number.isFinite(n)) {
            distancia = n;
        }
    }
    const diasViagem = distancia < 300 ? 1 : 4;
    return diasGozo + diasViagem - 1;
};

const ModalEditFolga = ({ folga, fetchData }) => {

    const { closeModal } = useModal();
    const { notifySuccess, notifyError } = useToast();
    const api = useApi();

    const [loading, setLoading] = useState(false);

    const [dataFolga, setDataFolga] = useState(toInputDate(folga?.data));
    const [dataPagamento, setDataPagamento] = useState(toInputDate(folga?.data_pagamento));
    const [dataRetorno, setDataRetorno] = useState(toInputDate(folga?.data_retorno));

    useEffect(() => {
        setDataFolga(toInputDate(folga?.data));
        setDataPagamento(toInputDate(folga?.data_pagamento));
        setDataRetorno(toInputDate(folga?.data_retorno));
    }, [folga]);

    const handleChangeDataFolga = (value) => {
        setDataFolga(value);

        if (value) {
            const base = new Date(`${value}T00:00:00`);
            base.setDate(base.getDate() - 60);
            const sugerido = `${base.getFullYear()}-${String(base.getMonth() + 1).padStart(2, '0')}-${String(base.getDate()).padStart(2, '0')}`;
            setDataPagamento(sugerido);
        }

        // Recalcula retorno em tempo real (regra alinhada ao backend; usuário pode editar depois).
        const inc = incrementoRetornoPorFolga(folga);
        setDataRetorno(value ? addDaysISO(value, inc) : '');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {

            await api.post('/Painel/API/Colaborador/UpdateFolga/', {
                id: folga.id,
                matricula: folga.matricula,
                data_folga: dataFolga,
                data_pagamento: dataPagamento,
                data_retorno: dataRetorno
            });

            await fetchData();
            notifySuccess("Folga atualizada com sucesso.");
            closeModal();

        } catch (e) {
            console.error(e);
            const msg = e?.response?.data?.message || "Erro ao atualizar folga.";
            notifyError(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Overlay state={true}>
                <Modal size="md" header={true} close={closeModal}>
                    <Formulario onSubmit={handleSubmit}>
                        <FormComp
                            title="DATA INÍCIO FOLGA"
                            type="date"
                            valor={dataFolga}
                            changeFunc={(e) => handleChangeDataFolga(e.target.value)}
                            required
                        />
                        <FormComp
                            title="DATA DE RETORNO"
                            type="date"
                            valor={dataRetorno}
                            changeFunc={(e) => setDataRetorno(e.target.value)}
                        />
                        <FormComp
                            title="DATA DO PAGAMENTO"
                            type="date"
                            valor={dataPagamento}
                            changeFunc={(e) => setDataPagamento(e.target.value)}
                        />
                        <FormComp
                            type="submit"
                            valor="SALVAR"
                        />
                    </Formulario>
                </Modal>
            </Overlay>
            {loading && (
                <Overlay state={true}>
                    <Modal size="sm">
                        <SmallLoading />
                    </Modal>
                </Overlay>
            )}
        </>
    );
};

export default ModalEditFolga;
